import { backendApi } from "../dynamicBAseQuery";

export const CandidateProfilesApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        candidateGridDatas: builder.mutation({
            query: (args) => ({
                method: 'POST',
                url: `viewAllCandidate`,
                params: args
            })
        }),
        overAllCandidate: builder.mutation({
            query: (args) => ({
                method: 'POST',
                url: `overAllCandidate`,
                params: args
            })
        }),
        offeredCandidates: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `getAllOfferedCandidate`,
                body: { ...args }
            })
        }),
        selectedCandidates: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `getAllSelectedClient`,
                body: { ...args }
            })
        }),
        getEmailDropdown: builder.query({
            query: () => ({
                method: "GET",
                url: `usersDropDown`
            })
        }),

        getTechnologies: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "viewKeywords",
                body: { ...args }
            })
        }),

        addCandidateDatas: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "saveCandidateDetails",
                body: { ...args }
            })
        }),

        getCandidateDetail: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "viewCandidate",
                body: { ...args }
            })
        }),

        viewCandidateHistory: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "eventsHistory",
                body: { ...args }
            })
        }),

        positionDropdown: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "positionDropdown",
                body: { ...args }
            })
        }),

        selectedJobPosition: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "selectJobPosition",
                body: { ...args }
            })
        }),

        getProfilEvent: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "getProfilEvent",
                body: { ...args }
            })
        }),
        eventDropDown: builder.query({
            query: () => ({
                method: "GET",
                url: `eventDropDown`
            })
        }),

        updateEvent: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "update",
                body: { ...args }
            })
        }),
        viewHistory: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "eventsHistory",
                body: { ...args }
            })
        }),
        deleteEventHistory: builder.mutation({
            query: (args) => ({
                method: "DELETE",
                url: "deleteEventHistory",
                body: { ...args }
            })
        }),
        viewAllReferralCandidate: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "viewAllReferralCandidate",
                params: args
            })
        }),
        ActiveJobDropDown: builder.query({
            query: () => ({
                method: "GET",
                url: `ActiveJobDropDown`
            })
        }),
        viewInternalReferralCandidate: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "viewInternalReferralCandidate",
                params: args
            })
        }),
        joinedCandidate: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "getAllJoinedCandidate",
                body: { ...args }
            })
        }),

        getCandidateCommissionList: builder.mutation({
            query: (args) => ({
                method: 'POST',
                url: 'getCandidateCommissionList',
                body: { ...args }
            })
        }),

        invoiceUpdateByHistory: builder.mutation({
            query: (args) => ({
                method: 'POST',
                url: 'invoiceUpdateByHistory',
                params: args
            })
        }),
    })
})

export const {
    useCandidateGridDatasMutation,
    useOfferedCandidatesMutation,
    useSelectedCandidatesMutation,
    useGetEmailDropdownQuery,
    useGetTechnologiesMutation,
    useGetCandidateDetailMutation,
    useViewCandidateHistoryMutation,
    usePositionDropdownMutation,
    useSelectedJobPositionMutation,
    useGetProfilEventMutation,
    useEventDropDownQuery,
    useUpdateEventMutation,
    useViewHistoryMutation,
    useDeleteEventHistoryMutation,
    useViewAllReferralCandidateMutation,
    useActiveJobDropDownQuery,
    useViewInternalReferralCandidateMutation,
    useJoinedCandidateMutation,
    useGetCandidateCommissionListMutation,
    useInvoiceUpdateByHistoryMutation,
    useOverAllCandidateMutation,
} = CandidateProfilesApi